export const crmIntegrationsKeys = {
  vinsolutionUsersList: (dealerId: number) =>
    ['VINSOLUTION_USERS_LIST', dealerId] as const,
  accountManagers: () => ['ACCOUNT_MANAGERS'] as const,
};
